module.exports = __webpack_public_path__ + "static/media/Save Blue.108eb8f7.svg";